module.exports = __webpack_public_path__ + "img/icon-question-rating-group-star.dc99db50.svg";